<template>
  <GfrTitle :class="['app-docs-title']" :level="1" :placement="$route.params.lang === 'ar' ? 'right' : 'left'">
    <slot />
  </GfrTitle>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.app-docs-title {
  @apply text-m-h2 font-medium max-lg:text-[22px] max-lg:leading-[32px];
}
</style>
